import React from 'react';

const Button = ({classNames, onClick, buttonIcon, buttonTitle, disabled}) => {
    return (
        <div>
            <button className={classNames} disabled={disabled} onClick={onClick}>{buttonIcon}{buttonTitle}</button>
        </div>
    );
}

export default Button;